import { render, staticRenderFns } from "./label-slot.component.vue?vue&type=template&id=54355a2d&scoped=true&"
import script from "./label-slot.component.vue?vue&type=script&lang=ts&"
export * from "./label-slot.component.vue?vue&type=script&lang=ts&"
import style0 from "./label-slot.component.vue?vue&type=style&index=0&id=54355a2d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54355a2d",
  null
  
)

export default component.exports